import { render } from "./ModalConfirmProposal.vue?vue&type=template&id=032e3590&scoped=true"
import script from "./ModalConfirmProposal.vue?vue&type=script&lang=js"
export * from "./ModalConfirmProposal.vue?vue&type=script&lang=js"

import "./ModalConfirmProposal.vue?vue&type=style&index=0&id=032e3590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032e3590"]])

export default __exports__